import { EventGeneric, SiteActivityEvent } from '@cms-max/cms-browser-api-client'

/**
 * @param defaults Defaults to set on the event
 * @param partialEvent A partial event
 * @returns an (event) object with both the defaults and partialEvent object properties. If defaults and partialEvent have the same key, the partialEvent value is used
 */
export const createEventWithDefaults = (
  defaults: EventGeneric<any, any>,
  partialEvent: EventGeneric<any, any>
): SiteActivityEvent => {
  // TODO: Get rid of `any` types used and do something fancy with `Omit`
  const event: SiteActivityEvent = {}
  if (partialEvent.core) {
    event.core = {
      ...defaults.core,
      ...partialEvent.core
    }
  }
  if (partialEvent.tealium) {
    event.tealium = {
      ...defaults.tealium,
      ...partialEvent.tealium
    }
  }
  return event
}
